import { Col, Row } from "antd";

import BlogItemThree from "./../../Common/Components/BlogItemThree";
import { DraggableBox } from "modules/Common/Components/DraggableBox";

const ArticlesListContainer = (props) => {
  const { articles, inEditionSmartSourced, isCampaign } = props;
  return (
    // <React.Fragment>
    <Row gutter={{ xs: 24, sm: 24, md: 24, lg: 24 }} className="list-style">
      <Col className="gutter-row" span={24}>
        {articles.map((article, index) => (
          <DraggableBox articleId={article.id} blogItem={article} key={index}>
            <BlogItemThree
              isCampaign={isCampaign}
              key={article.id}
              articleId={article.id}
              title={article.title}
              imgUrl={article.image_url}
              publishDate={article.publish_date}
              website={article.website}
              description={article.description}
              entities={article.entities}
              link={article.link}
              isCurated={article.is_curated}
              isCMS={article.is_cms}
              isFav={article.is_favourite}
              addBlog={true}
              inEditionSmartSourced={inEditionSmartSourced}
              companyName={article.companyName}
              categoryColor={article.alerts}
              categoryTitle={article.alerts}
              fullDescription={article.fullDescription}
              inArticleListContainer={true}
            />
          </DraggableBox>
        ))}
      </Col>
    </Row>
    // </React.Fragment>
  );
};

export default ArticlesListContainer;
